import { Quotes } from '@/payload-types'
import Image from 'next/image'
import { Blockquote } from 'flowbite-react'
import RenderRichTexComponent from '@/components/rich-text-render/richTextRender'
import Link from 'next/link'
import { formatDate } from '@/lib/postFunctions'
import { CANARY_MISSION } from '@/enum/enum'
interface IProps {
  quoteData?: Quotes
}

export const Quote = ({ quoteData }: IProps) => {
  const link = quoteData?.link?.split('/')[2] ? quoteData?.link?.split('/')[2] : quoteData?.link
  link?.concat(', ')
  const date = quoteData?.date ? formatDate(quoteData?.date) : ''
  const payloadURL = process.env.NEXT_PUBLIC_PAYLOAD_URL ? process.env.NEXT_PUBLIC_PAYLOAD_URL : ''
  const imageURL =
    quoteData?.author === 'external'
      ? typeof quoteData?.authorPicture === 'object' && quoteData.authorPicture != undefined
        ? `${payloadURL}${quoteData.authorPicture?.sizes?.large?.url}`
        : null
      : typeof quoteData?.profileAuthor?.value === 'object'
      ? quoteData?.profileAuthor?.relationTo === 'legacyprofiles'
        ? quoteData?.profileAuthor?.value?.profileImage
        : typeof quoteData?.profileAuthor?.value?.profileImage === 'object'
        ? `${payloadURL}${quoteData?.profileAuthor?.value?.profileImage?.sizes?.large?.url}`
        : null
      : null
  return (
    <div
      className={`rounded-3xl flex px-4 flex-col  items-center pt-4 pb-4 sm:flex-row bg-${quoteData?.color?.backgroundColor}`}
    >
      <div className="flex flex-col items-center justify-center mx-2">
        {quoteData?.author === 'external'
          ? typeof quoteData?.authorPicture === 'object' && (
              <div className="relative w-32 h-32">
                {imageURL && (
                  <Image
                    className="w-32 h-32 rounded-full object-cover"
                    src={`${imageURL}`}
                    alt={`${quoteData?.authorPicture?.title}`}
                    fill
                  />
                )}
              </div>
            )
          : typeof quoteData?.profileAuthor?.value === 'object' && (
              <Link href={`${CANARY_MISSION.BASIC_URL}/individual/${quoteData?.profileAuthor?.value?.slug}`} target="_blank" className="relative w-32 h-32" prefetch={false}>
                {
                  <Image
                    className="w-32 h-32 rounded-full object-cover"
                    src={`${imageURL}`}
                    alt={`${
                      typeof quoteData.profileAuthor.value.profileImage === 'object'
                        ? quoteData.profileAuthor.value.profileImage?.title
                        : `${quoteData.profileAuthor.value.slug} Quote Image`
                    }`}
                    fill
                  />
                }
              </Link>
            )}
        {quoteData?.author === 'external' ? (
          <div className="text-center my-2 font-semibold text-sm	felx justify-center items-center">
            <>{quoteData?.fullName}</>
          </div>
        ) : (
          <div className="text-center my-2 font-semibold text-sm felx justify-center items-center	">
            <Link href={typeof quoteData?.profileAuthor?.value === 'object' ? `${CANARY_MISSION.BASIC_URL}/individual/${quoteData?.profileAuthor?.value?.slug}` : ''} target="_blank" prefetch={false}>
              {typeof quoteData?.profileAuthor?.value === 'object' &&
                (quoteData?.profileAuthor.relationTo === 'legacyprofiles'
                  ? quoteData?.profileAuthor.value.fullName
                  : quoteData?.profileAuthor.relationTo === 'publicprofiles' &&
                    typeof quoteData?.profileAuthor.value.profileEntity === 'object'
                  ? quoteData?.profileAuthor.value.profileEntity.fullName
                  : '')}
            </Link>
          </div>
        )}
      </div>
      <div className="w-full sm:w-4/5 text-center sm:text-left ">
        <Blockquote
          className={`text-xl text-center not-italic font-semibold text-${
            quoteData?.color?.color ? quoteData?.color?.color : 'gray-900'
          }`}
        >
          <div>
            {' '}
            <RenderRichTexComponent richTextField={quoteData?.richText} />
          </div>
        </Blockquote>
        <div
          className={`pt-4 text-base text-center font-semibold text-${
            quoteData?.color?.color ? quoteData?.color.color : 'gray-900'
          }`}
        ></div>
        <div className="flex justify-center text-gray-500 text-sm font-semibold">
          {quoteData?.link ? (
            <Link href={`${quoteData?.link}`} target="_blank" prefetch={false}>
              {link},
            </Link>
          ) : (
            <></>
          )}
          <p className="mx-1 ">{date}</p>
        </div>
      </div>
    </div>
  )
}
